module.exports = __webpack_public_path__ + "media/images/common/list_pink-ad8acdb06c287e5fab747a0deda1d789.gif";